import React from 'react';

const formatMoney = (value) => {
	const amount = parseFloat(value);
	if (!Number.isFinite(amount)) {
		return '$0.00';
	}
	if (amount < 0) {
		return `-$${Math.abs(amount).toFixed(2)}`;
	}
	return `$${amount.toFixed(2)}`;
};

const moneyValue = (value) => {
	const amount = parseFloat(value);
	return Number.isFinite(amount) ? amount : 0;
};

const SummaryRow = ({label, value, bold = false, muted = false}) => (
	<div style={{
		display: 'flex',
		justifyContent: 'space-between',
		fontWeight: bold ? 600 : 400,
		fontSize: bold ? '1.1rem' : '1rem',
		padding: '4px 0',
		color: muted ? '#c62828' : 'inherit',
	}}>
		<span>{label}</span>
		<span>{formatMoney(value)}</span>
	</div>
);

const CheckoutModule = ({config}) => {
	const items = Array.isArray(config?.items) ? config.items : [];
	const subtotal = config?.subtotal ?? config?.total ?? '0.00';
	const tax = config?.tax ?? '0.00';
	const total = config?.total ?? '0.00';
	const cashDiscountAmount = moneyValue(config?.cash_discount_amount);
	const cashDiscountPercentage = moneyValue(config?.cash_discount_percentage);
	const membershipDiscountAmount = moneyValue(config?.membership_discount_amount);
	const globalDiscountAmount = moneyValue(config?.global_discount_amount_applied);
	const globalDiscountLabel = config?.global_discount_label || 'Discount';
	const ccFee = moneyValue(config?.cc_fee);
	const ccFeePercent = moneyValue(config?.cc_fee_percent);

	return (
		<div style={{padding: '16px', border: '1px solid #dcdcdc', borderRadius: '6px'}}>
			<h5 style={{marginTop: 0}}>{config?.title || 'Your Order'}</h5>
			{!items.length ? (
				<p style={{marginBottom: 0, color: '#666'}}>No items in this checkout yet.</p>
			) : (
				<table style={{width: '100%', borderCollapse: 'collapse', marginBottom: '12px'}}>
					<thead>
						<tr style={{borderBottom: '1px solid #e0e0e0', textAlign: 'left'}}>
							<th style={{padding: '8px 4px'}}>Item</th>
							<th style={{padding: '8px 4px', width: '60px'}}>Qty</th>
							<th style={{padding: '8px 4px', width: '90px', textAlign: 'right'}}>Total</th>
						</tr>
					</thead>
					<tbody>
						{items.map((item, index) => {
							const lineDiscount = moneyValue(item.discountAmount);
							const lineCashDiscount = moneyValue(item.cashDiscountAmount);
							return (
								<tr key={`checkout-line-${index}`} style={{borderBottom: '1px solid #f0f0f0'}}>
									<td style={{padding: '8px 4px'}}>
										{item.name || 'Item'}
										{(lineDiscount > 0 || lineCashDiscount > 0) ? (
											<div style={{color: '#c62828', fontSize: '0.85rem'}}>
												{lineCashDiscount > 0 ? `Cash discount ${formatMoney(lineCashDiscount)}` : null}
												{lineCashDiscount > 0 && lineDiscount > 0 ? ' · ' : null}
												{lineDiscount > 0 ? `Discount ${formatMoney(lineDiscount)}` : null}
											</div>
										) : null}
									</td>
									<td style={{padding: '8px 4px'}}>{item.quantity || 1}</td>
									<td style={{padding: '8px 4px', textAlign: 'right'}}>{formatMoney(item.lineTotal)}</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			)}
			<div style={{paddingTop: '8px', borderTop: items.length ? '1px solid #e0e0e0' : 'none'}}>
				<SummaryRow label="Subtotal" value={subtotal} />
				{membershipDiscountAmount > 0 ? (
					<SummaryRow label="Membership Discount" value={-membershipDiscountAmount} muted />
				) : null}
				{cashDiscountAmount > 0 ? (
					<SummaryRow
						label={cashDiscountPercentage > 0
							? `Cash Discount (${cashDiscountPercentage}%)`
							: 'Cash Discount'}
						value={-cashDiscountAmount}
						muted
					/>
				) : null}
				{globalDiscountAmount > 0 ? (
					<SummaryRow label={globalDiscountLabel} value={-globalDiscountAmount} muted />
				) : null}
				<SummaryRow label="Tax" value={tax} />
				{ccFee > 0 ? (
					<SummaryRow
						label={ccFeePercent > 0
							? `CC Fee (${ccFeePercent.toFixed(2)}%)`
							: 'CC Fee'}
						value={ccFee}
					/>
				) : null}
				<div style={{borderTop: '2px solid #333', marginTop: '8px', paddingTop: '8px'}}>
					<SummaryRow label="Total" value={total} bold />
				</div>
			</div>
		</div>
	);
};

export default CheckoutModule;
